<div [class]="classPrefix('MainPod')" #datePicker>
  <div [class]="classPrefix('MainInput0')" (click)="toggleDatePicker()">
    <p>{{dateInput.text | translate}}</p>
  </div>
</div>
